import { camelize, decamelize } from 'humps'
import type { i18n } from 'i18next'
import { z } from 'zod'

export const objectToFormData = (obj: Record<string, ArrayBuffer | string | number | File>) => {
  const formData = new FormData()
  for (const key in obj) {
    const formattedKey = decamelize(key)
    const value = obj[key]
    if (value instanceof ArrayBuffer) {
      formData.append(formattedKey, new Blob([value]))
    }
    else if (value instanceof File) {
      formData.append(formattedKey, value)
    }
    else {
      formData.append(formattedKey, String(value))
    }
  }
  return formData
}

export const base64ToFile = (dataurl: string, filename: string) => {
  const arr = dataurl.split(',')
  const mime = arr[0]?.match(/:(.*?);/)?.[1]
  const bstr = atob(arr[arr.length - 1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)

  while (n--) {
    u8arr[n] = bstr.codePointAt(n) as number
  }
  return new File([u8arr], filename, { type: mime })
}

export const passwordSchema = (i18n: i18n) => z.string()
  .min(8)
  .refine(value => /[A-Z]/.test(value), {
    error: i18n.t('errors.passwordUppercase'),
  })
  .refine(value => /[!@#$%^&*(),.?":{}|<>]/.test(value), {
    error: i18n.t('errors.passwordSpecialChars'),
  })

export const setErrorsFromRailsPayload = (
  payload: Record<string, string[]>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setError: (key: any, message: string) => void,
  i18n: i18n,
) => {
  Object.keys(payload).forEach((key) => {
    payload[key].forEach((value) => {
      setError(camelize(key), i18n.t(`errors.${camelize(value)}`))
    })
  })
}
